// Trocar cartão: o Brick do checkout (CardPanel) só gera o token. O
// `amount` é o preço do ciclo atual porque o Brick exige um valor para
// renderizar; nada é cobrado — o PATCH leva só token, bandeira e final.
import React from "react";

import AerosDialog from "../AerosDialog";
import CardPanel from "../SubscriptionCheckout/CardPanel";
import ManageFooter from "./ManageFooter";
import Notice from "./Notice";
import useSubscription from "../../hooks/useSubscription";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const ChangeCardDialog = ({ open, onClose, publicKey, amount, onDone }) => {
  const { patchMe } = useSubscription();

  const handleSubmit = async (formData, additionalData) => {
    try {
      await patchMe({
        action: "changeCard",
        cardToken: formData?.token,
        cardBrand: formData?.payment_method_id || null,
        cardLast4: additionalData?.lastFourDigits || null,
      });
      onDone(i18n.t("subscription.manage.cardChanged"));
    } catch (err) {
      toastError(err);
      // Rejeitar devolve o Brick ao estado editável.
      throw err;
    }
  };

  return (
    <AerosDialog
      open={open}
      onClose={onClose}
      title={i18n.t("subscription.manage.cardTitle")}
      subtitle={i18n.t("subscription.manage.cardSubtitle")}
      width={520}
      footer={
        <ManageFooter cancelLabel={i18n.t("subscription.manage.close")} onCancel={onClose} />
      }
    >
      <Notice>{i18n.t("subscription.manage.cardNotice")}</Notice>
      {publicKey && amount > 0 ? (
        open && (
          <CardPanel
            publicKey={publicKey}
            amount={amount}
            maxInstallments={1}
            submitLabel={i18n.t("subscription.manage.cardSubmit")}
            onSubmit={handleSubmit}
          />
        )
      ) : (
        <Notice tone="warn">{i18n.t("subscription.manage.cardUnavailable")}</Notice>
      )}
    </AerosDialog>
  );
};

export default ChangeCardDialog;
